import React from 'react';
import { Trash2 } from 'lucide-react';
import { RiCloseLine, RiDeleteBin5Line } from 'react-icons/ri';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  itemType?: string;
  itemName?: string;
  loading?: boolean;
}

const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  itemType = "item",
  itemName,
  loading = false
}: DeleteConfirmationModalProps) => {
  if (!isOpen) return null;

  return (
    <>
    <Modal
      backdrop="static"
      centered={true}
      toggle={onClose}
      isOpen={isOpen}
      className="rv-modal"
    >
      <ModalHeader className="w-100 justify-content-center p-13 position-relative rv-breadcrumb-border ">
        Delete {itemType}
        <button
          type="button"
          className="close-button-currency position-absolute top-0 end-0 mt-1 me-3 border-0 bg-transparent fs-3"
          onClick={onClose}
        >
          &times;
        </button>
      </ModalHeader>
      <ModalBody className="fs-5 fw-bold text-center">
        Are you sure you want to delete this {itemType.toLowerCase()}
          {itemName ? ` "${itemName}"` : ''}?
      </ModalBody>
      <ModalFooter className="d-flex justify-content-center align-items-center p-4">
        <div className="d-flex flex-row gap-3">
            <Button
              onClick={onClose}
              className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
            >
              <i className="ri-close-fill label-icon secondary-label-icon align-middle fs-16 me-1" />

              <span className="ps-2 ms-2 me-1 modal-btn">
                Cancel
              </span>
            </Button>
          <Button
            className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
            onClick={loading ? () => { return } : onConfirm}
          >
            <i className="ri-delete-bin-line label-icon align-middle fs-16 me-1"></i>
            <span className="ps-3 px-2 ms-2 me-1 modal-btn">{loading ? "Deleting..." : "Yes, Delete It"}</span>
          </Button>
        </div>
      </ModalFooter>
    </Modal>
    </>
  );
};

export default DeleteConfirmationModal;